import TableHeader from '@tiptap/extension-table-header';

export default TableHeader.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            style: {
                parseHTML: (element) => element.style?.cssText,
            },
            class: {
                default: null,
            },
            id: {
                default: null,
            },
        };
    },
});
